import { render, staticRenderFns } from "./TableFactureObligie.vue?vue&type=template&id=1f8ddcce&"
import script from "./TableFactureObligie.vue?vue&type=script&lang=js&"
export * from "./TableFactureObligie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports